export const parseAsJson = <T>(decoder: (s: string) => string = (s) => s) => (
  str: string
) => JSON.parse(decoder(str)) as T;
